export default __webpack_public_path__ + "assets/images/brand.6b2c92380def694d602f18c0a179f722.svg";